import { QuickContactResponse } from '../../../model/quick-contact-response';
import { QuickContactTableRow } from '../model/quick-contact-table-row';

export const mapQuickContactResponseToTableRow = (quickContact: QuickContactResponse): QuickContactTableRow => {
  return { ...quickContact, uniqueId: `${quickContact.type}${quickContact.id}` };
};
